import { Text } from '@betterment/samba-react';
import { Card, Flex } from '@betterment/style-closet-react';

import CopyableReferralKey from './CopyableReferralKey';
import OfferDetails from './OfferDetails';
import { useReferralSenderOffer } from './ReferAFriendProvider';
import SendInviteForm from './SendInviteForm';

const TRACKING_MODULE_NAME = 'ReferAFriendInvitationCard';

const ReferAFriendInvitationCard: React.FC = () => {
  const { referralFulfillments, maxReferralRewardCount } = useReferralSenderOffer();
  const remainingReferrals = maxReferralRewardCount - referralFulfillments;

  return (
    <Card>
      <Card.Slot name="header">Refer a friend</Card.Slot>
      <Card.Slot name="body">
        <Text
          as="p"
          css={{
            marginBottom: 'space.0',
          }}
        >
          Send an invite email or use your personalized link to refer a friend.
        </Text>
        <SendInviteForm trackingModule={TRACKING_MODULE_NAME} />
        <CopyableReferralKey trackingModule={TRACKING_MODULE_NAME} />
        {referralFulfillments > 0 && (
          <Flex justifyContent="center" p="8" bg="bmtBlue10" mt="8">
            {referralFulfillments >= maxReferralRewardCount ? (
              <Text
                as="p"
                css={{
                  marginBottom: 'space.0',
                }}
              >
                You have no more available rewards but you can continue referring friends.
              </Text>
            ) : (
              <Text
                as="p"
                data-testid="remaining-referrals"
                css={{
                  marginBottom: 'space.0',
                }}
              >
                <strong>{remainingReferrals}</strong> of {maxReferralRewardCount} referral rewards left
              </Text>
            )}
          </Flex>
        )}
      </Card.Slot>
      <Card.Slot name="footer">
        <OfferDetails trackingModule={TRACKING_MODULE_NAME} />
      </Card.Slot>
    </Card>
  );
};

export default ReferAFriendInvitationCard;
